import React from 'react';
import {Post as PostType} from '../types';

type PostProps = {
    post: PostType;
};

export const Post: React.FunctionComponent<PostProps> = ({
                                                             post
                                                         }) => {
    const containerClasses = [
        'col-8',
        'offset-2',
        'wp-post',
        post?.tags?.includes('alert-warning') && 'alert-warning',
        post?.tags?.includes('alert-pink') && 'alert-pink'
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <div className={containerClasses}>
            <h2 className="wp-post-title">{post.title}</h2>
            <div className="wp-post-content" dangerouslySetInnerHTML={{__html: post.content}}/>
        </div>
    );
};